var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _circle3, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28206_25427)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0002,
    cy: 46.0002,
    r: 35,
    fill: "#E4DCF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28206_25427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 71,
    height: 70
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9998,
    cy: 46,
    r: 35,
    fill: "#E4DCF3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28206_25427)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.9148,
    y: 26.6382,
    width: 47.6596,
    height: 55.1064,
    rx: 1.86701,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1288,
    y: 39.2998,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1288,
    y: 52.7041,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1288,
    y: 46.0022,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1288,
    y: 59.4062,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1288,
    y: 66.1084,
    width: 28.2979,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6169 34.6187V30.9965H40.7885C41.4652 30.9965 42.042 31.3835 42.042 32.0629C42.042 32.5192 41.7446 32.8652 41.3345 33.0062L42.3419 34.6187H41.5959L40.7039 33.0703H40.4937H40.2681V34.6187H39.6169ZM40.2732 32.5397H40.8474C41.1935 32.5243 41.3986 32.3448 41.3986 32.0731C41.3986 31.7732 41.1653 31.5784 40.7936 31.5784H40.2732V32.5397ZM43.7672 34.6699C42.9751 34.6699 42.4547 34.0573 42.4547 33.3318C42.4547 32.6089 42.9751 32.0039 43.7672 32.0039C44.5593 32.0039 45.0797 32.6089 45.0797 33.3318C45.0797 34.0573 44.5593 34.6699 43.7672 34.6699ZM43.7672 34.1316C44.2415 34.1316 44.4286 33.7522 44.4286 33.3318C44.4286 32.9114 44.2415 32.5448 43.7672 32.5448C43.2955 32.5448 43.1058 32.9114 43.1058 33.3318C43.1058 33.7522 43.2955 34.1316 43.7672 34.1316ZM46.4332 34.6699C45.7616 34.6699 45.5052 34.1316 45.5052 33.5958V32.0577H46.123V33.5164C46.123 33.8522 46.2922 34.0931 46.6127 34.0931C46.9639 34.0931 47.1895 33.9034 47.1895 33.4574V32.0577H47.8098V34.6187H47.1895V34.3187C46.9844 34.5725 46.687 34.6699 46.4332 34.6699ZM49.4607 34.6699C48.9608 34.6699 48.6609 34.3777 48.6609 33.9111V32.5807H48.2482V32.0577H48.6711V31.422L49.2864 30.976V32.0577H49.9272V32.5807H49.2864V33.8009C49.2864 34.047 49.4069 34.1188 49.5709 34.1188C49.7017 34.1188 49.8427 34.0675 49.9272 34.0265V34.593C49.8324 34.6289 49.6478 34.6699 49.4607 34.6699ZM51.5499 34.6699C50.6681 34.6699 50.2528 34.0367 50.2528 33.3472C50.2528 32.6807 50.6425 32.0039 51.5089 32.0039C52.4061 32.0039 52.6958 32.7242 52.6958 33.2959C52.6958 33.401 52.6855 33.5061 52.6727 33.542H50.9142C50.968 33.8778 51.1526 34.1034 51.5551 34.1034C51.7858 34.1034 51.9908 34.0316 52.1703 33.8317L52.601 34.2085C52.3215 34.5187 51.9806 34.6699 51.5499 34.6699ZM50.9142 33.0908H52.0806C52.0806 33.0344 52.0754 32.9806 52.0601 32.9293C51.996 32.6653 51.7755 32.5294 51.5038 32.5294C51.1346 32.5294 50.9731 32.7704 50.9142 33.0908Z",
    fill: "#7953D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0619 48.1352C49.6124 47.6675 49.0755 47.2933 48.4818 47.0338C47.8881 46.7743 47.2492 46.6347 46.6017 46.6229C45.9542 46.6111 45.3108 46.7274 44.7081 46.9652C44.1054 47.2029 43.5553 47.5574 43.0892 48.0085C43.0513 48.0451 43.0141 48.0824 42.9769 48.1205C42.0334 49.0943 41.5043 50.3982 41.5015 51.7563C41.4988 53.1145 42.0226 54.4205 42.9622 55.3981L46.2138 58.7345C46.2508 58.774 46.2956 58.8052 46.3455 58.8261C46.3953 58.847 46.4489 58.857 46.5029 58.8556C46.5573 58.8585 46.6116 58.8491 46.6619 58.8281C46.7122 58.8072 46.7571 58.7752 46.7935 58.7345L50.0465 55.3996C50.9949 54.431 51.5276 53.1283 51.5304 51.7706C51.5333 50.4128 51.0062 49.1078 50.0619 48.1352Z",
    fill: "#B29DE2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.4825,
    cy: 50.9914,
    r: 1.74772,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.376 43.7681C41.6468 43.7681 37.8122 47.6027 37.8122 52.3319C37.8122 57.0611 41.6468 60.8957 46.376 60.8957C51.1053 60.8957 54.9399 57.0611 54.9399 52.3319C54.9399 47.6027 51.1053 43.7681 46.376 43.7681ZM46.376 59.4429C42.4497 59.4429 39.265 56.2583 39.265 52.3319C39.265 50.6306 39.8633 49.0669 40.8612 47.8435L50.8644 57.8468C49.641 58.8446 48.0773 59.4429 46.376 59.4429ZM51.8909 56.8203L41.8877 46.817C43.1111 45.8192 44.6747 45.2209 46.376 45.2209C50.3024 45.2209 53.4871 48.4055 53.4871 52.3319C53.4871 54.0332 52.8887 55.5969 51.8909 56.8203Z",
    fill: "#8A63F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28206_25427",
    x: 0.574659,
    y: 0.574713,
    width: 90.8511,
    height: 90.8511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.21277
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28206_25427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28206_25427",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAssignment);
export default __webpack_public_path__ + "static/media/empty_assignment.1aa3ed9521f670a2f33834a51d28e950.svg";
export { ForwardRef as ReactComponent };